import React, {useContext} from 'react'
import CircleUnchecked from '@material-ui/icons/RadioButtonUnchecked'
import CircleChecked from '@material-ui/icons/CheckCircleOutline'
import {Checkbox, Typography} from '@material-ui/core'
import useStyles from '../FooterStyles'
import I18nContext from '../../../../services/I18n/I18nContext'
import {Quote} from '../../../../services/quote/QuoteProvider'
import {currency} from '../../../containers/Services/components/ServiceItem'
import {INCENTIVE_BUSINESS_TYPE, RENT_BUSINESS_TYPE} from '../../BusinessTypeSwitch/BusinessTypeSwitch';

const incentives2MonthlyPrice = 23.97;

interface IMonthlyCalculationProps {
    showAdditionalFooter: boolean,
    quote: Quote
}

const MonthlyCalculation = (props: IMonthlyCalculationProps) => {

    const classes = useStyles()
    const {translate} = useContext(I18nContext)
    const {quote} = props
    let message = quote.totalMonthly > 0 ? translate('monthlyInfoMessage') : translate('noService')
    const deviceItem = quote.items.find(i => i.id === 'device_one')
    const basicService = quote.items.find(i => i.id === 'basicService1')
    const basicServicePrice = basicService && (basicService.price * (deviceItem ? deviceItem.quantity : 1))
    const option1 = quote.items.find(i => i.id === 'option1')
    const option1Price = option1 ? (option1.price * (deviceItem ? deviceItem.quantity : 1)) : 0
    const option2 = quote.items.find(i => i.id === 'option2')
    const option2Price = option2 ? (option2.price * option2.quantity) : 0
    const option2PreviousPrice = option2 ? ((option2.previousPrice || 0) * option2.quantity) : 0
    const internetOptionItemInfo = !!option2 && !!deviceItem && quote.businessType !== INCENTIVE_BUSINESS_TYPE ? `Nakon 2 mjeseca ${option2PreviousPrice.toFixed(2)} ${currency}` : null
    const internetOptionInfo = !!option2 && !!deviceItem && quote.businessType !== INCENTIVE_BUSINESS_TYPE ? `* Nakon 2 mjeseca ${(quote.totalMonthly + option2PreviousPrice).toFixed(2)}${currency}/mj + PDV` : null
    const option4 = quote.items.find(i => i.id === 'option4')
    const option4Price = option4 ? (option4.price * (deviceItem ? deviceItem.quantity : 1)) : 0
    const deviceFixedPrice = deviceItem && ((deviceItem.price || 0) * deviceItem.quantity)
    const incentive1 = quote.items.find(i => i.id === 'incentive_1')
    const incentive2 = quote.items.find(i => i.id === 'incentive_2')

    message = (incentive1 || incentive2) ? (!incentive2 ? translate('monthlyInfoMessage') : `${translate('after12months')} ${(incentives2MonthlyPrice * incentive2.quantity).toFixed(2)}${currency}/mj + PDV`) : message;

    return (
        <div className={classes.fixedCalculationRoot}>
            <div className={classes.row}>
                <Typography className={classes.label}>
                    {translate('monthly')}
                </Typography>
                {
                    quote.totalMonthly > 0 && (
                        <Typography className={classes.mainPrice}>
                            {quote.totalMonthly.toFixed(2)} {currency}/mj
                        </Typography>
                    )
                }
                {
                    quote.totalMonthly > 0 && (
                        <Typography className={classes.secondaryLabel}>
                            {translate('pdv')}
                        </Typography>
                    )
                }
            </div>
            <div className={classes.column}>
                <Typography className={classes.message}>
                    {message}
                </Typography>
                {internetOptionInfo && 
                    <Typography className={classes.message}>
                        {internetOptionInfo}
                    </Typography>
                }
            </div>
            {props.showAdditionalFooter && (
                <>
                    {(deviceItem && quote.businessType === RENT_BUSINESS_TYPE) && (
                        <div className={classes.row}>
                            <Checkbox
                                className={classes.actionCheckbox}
                                color='primary'
                                checked={true}
                                icon={<CircleUnchecked/>}
                                checkedIcon={<CircleChecked/>}
                            />
                            <div className={classes.additionalActionWrapper}>
                                <Typography className={classes.additionalActionMessage}>
                                    {deviceItem.title}
                                </Typography>
                                <Typography className={classes.additionalActionPrice}>
                                    {deviceFixedPrice?.toFixed(2)} {currency}
                                </Typography>
                            </div>
                        </div>
                    )}

                    {basicService && (
                        <div className={classes.row}>
                            <Checkbox
                                className={classes.actionCheckbox}
                                color='primary'
                                checked={true}
                                icon={<CircleUnchecked/>}
                                checkedIcon={<CircleChecked/>}
                            />
                            <div className={classes.additionalActionWrapper}>
                                <Typography className={classes.additionalActionMessage}>
                                    {basicService.title}
                                </Typography>
                                <Typography className={classes.additionalActionPrice}>
                                    {basicServicePrice?.toFixed(2)} {currency}
                                </Typography>
                            </div>
                        </div>
                    )}

                    {option1 && (
                        <div className={classes.row}>
                            <Checkbox
                                className={classes.actionCheckbox}
                                color='primary'
                                checked={true}
                                icon={<CircleUnchecked/>}
                                checkedIcon={<CircleChecked/>}
                            />
                            <div className={classes.additionalActionWrapper}>
                                <Typography className={classes.additionalActionMessage}>
                                    {option1.title}
                                </Typography>
                                <Typography className={classes.additionalActionPrice}>
                                    {option1Price?.toFixed(2)} {currency}
                                </Typography>
                            </div>
                        </div>
                    )}

                    {option2 && (
                        <div className={classes.row}>
                            <Checkbox
                                className={classes.actionCheckbox}
                                color='primary'
                                checked={true}
                                icon={<CircleUnchecked/>}
                                checkedIcon={<CircleChecked/>}
                            />
                            <div className={classes.additionalActionWrapper}>
                                <Typography className={classes.additionalActionMessage}>
                                    {option2.title}
                                </Typography>
                                <Typography className={classes.additionalActionPrice}>
                                    {option2Price?.toFixed(2)} {currency}
                                </Typography>
                                {internetOptionItemInfo && (
                                    <Typography className={classes.message} style={{marginLeft: 10}}>
                                        ({internetOptionItemInfo})
                                    </Typography>
                                )}       
                            </div>
                        </div>
                    )}

                    {option4 && (
                        <div className={classes.row}>
                            <Checkbox
                                className={classes.actionCheckbox}
                                color='primary'
                                checked={true}
                                icon={<CircleUnchecked/>}
                                checkedIcon={<CircleChecked/>}
                            />
                            <div className={classes.additionalActionWrapper}>
                                <Typography className={classes.additionalActionMessage}>
                                    {option4.title}
                                </Typography>
                                <Typography className={classes.additionalActionPrice}>
                                    {option4Price?.toFixed(2)} {currency}
                                </Typography>
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    )

}

export default MonthlyCalculation
